export enum FormPlaceholders {
  Input = 'Entrer du texte...',
  Select = 'Choisir une valeur...',
  Figures = 'Entrer des chiffres...',
  Number = 'Entrer un nombre...',
  Date = 'JJ/MM/AAAA',
  DateWithTime = 'JJ/MM/AAAA HH:mm',
  TextArea = 'Entrer du texte...',
}
